import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from "firebase/firestore"; // Importer Firestore

const firebaseConfig = {
    apiKey: "AIzaSyBHzy2CNkw3cG6jzgHyZhZ4yau99bEt5OA",
    authDomain: "forsides-advent-calendar-7f467.firebaseapp.com",
    projectId: "forsides-advent-calendar-7f467",
    storageBucket: "forsides-advent-calendar-7f467.appspot.com",
    messagingSenderId: "915181349342",
    appId: "1:915181349342:web:860ed2f7129d21f754954f",
    measurementId: "G-HQFC8JMHSJ"
  };

// Initialiser Firebase
const app = initializeApp(firebaseConfig);

// Initialiser Auth et Firestore
export const auth = getAuth(app);
export const db = getFirestore(app); // Exporter db pour Firestore
